import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/modules/shared.module';
import { ContractProfitabilityAnalysisDialogComponent } from './dialog/dialog.component';

@NgModule({
  declarations: [
    ContractProfitabilityAnalysisDialogComponent,
  ],
  entryComponents: [
    ContractProfitabilityAnalysisDialogComponent,
  ],
  providers: [
  ],
  imports: [
    SharedModule,
  ],
})
export class ContractProfitabilityAnalysisModule {}